import { ReadablePropEventBroker } from './ReadablePropEventBroker';
import { EMPTY_OBJECT } from '../arrayTools';
export class PropEventBroker extends ReadablePropEventBroker {
    set(value, options) {
        const currentValue = this.get();
        const validator = this._getValidator();
        let isChanged = false;
        const isValid = validator(value);
        if (isValid) {
            isChanged = currentValue !== value;
            if (isChanged) {
                this.setValueInner(value, options ?? EMPTY_OBJECT);
            }
        }
        return isChanged;
    }
}
//# sourceMappingURL=PropEventBroker.js.map